import React from "react";
import { useTranslation } from "react-i18next";

import { Operators } from "../../../../../../models/Operators";
import { ScoreType } from "../../../../../../utils/score";
import { HookFormSelect } from "../../../../../HookForm/Select";
import "./styles.scss";

export const HealthIndexDetailsInput = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`adminLocationAlertsPage.adminLocationAlertCreateModal.${key}`);

  const operatorOptions = Object.values(Operators).map((operator) => ({
    label: t(`fields.details.health_index.operator.${operator}`),
    value: operator,
  }));

  const healthIndexOptions = Object.values(ScoreType).map((healthIndex) => ({
    label: t(`fields.details.health_index.value.${healthIndex}`),
    value: healthIndex,
  }));

  return (
    <div className="health-index-details-input">
      <h3>{t("fields.details.health_index.label")}</h3>
      <div className="health-index-details-input-selects">
        <HookFormSelect
          className="health-index-details-input-health-index-select"
          name="details.health_index.value"
          options={healthIndexOptions}
        />
        <HookFormSelect
          className="health-index-details-input-operator-select"
          name="details.health_index.operator"
          options={operatorOptions}
        />
      </div>
    </div>
  );
};
